import { createContext } from "react";
import React, { useContext, useState } from "react";

const AccessContext = createContext();
export { AccessContext };

// Create a context
const BookingPageContext = createContext();

// Provider component
export const BookingPageProvider = ({ children }) => {
  const [bookingPageCount, setBookingPageCount] = useState("c0");

  return (
    <BookingPageContext.Provider
      value={{ bookingPageCount, setBookingPageCount }}
    >
      {children}
    </BookingPageContext.Provider>
  );
};

// Create a context for filters
const FilterContext = createContext();

// Provider component for filters
export const FilterProvider = ({ children }) => {
  const [filterState, setFilterState] = useState({
    userPageFilter: {},
    teamsPageFilter: {},
    appsAndMorePageFilter: undefined,
    bookingPageFilter: {},
    CurrentTab: 1,
  });

  return (
    <FilterContext.Provider value={{ filterState, setFilterState }}>
      {children}
    </FilterContext.Provider>
  );
};

export { FilterContext };
